module.exports = __webpack_public_path__ + "static/media/19a-06_ST-2019-216x183cm-oleo-sobre-madera.35fe1de4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/19a/19a-06_ST-2019-216x183cm-oleo-sobre-madera.jpg
// module id = 241
// module chunks = 0